module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kk3Ao"))).then(() => parcelRequire('hEqeo'));